import contract from '../contracts/guestRules.json';

export const GUEST_RULE_VERSION = contract.version;
export const GUEST_ROWS = Object.freeze(contract.categories.map((row) => Object.freeze({ ...row })));
export const GUEST_AGE_HELP = Object.freeze(Object.fromEntries(
  GUEST_ROWS.flatMap((row) => [row.key, row.plural, row.label].map((key) => [key, row.helper])),
));
export const GUEST_BOOKING_REQUIREMENT = contract.bookingRequirement;
export const PORTAL_GUEST_LIMITS = Object.freeze({ ...contract.limits });

export const capPortalGuests = (value = PORTAL_GUEST_LIMITS.maxGuests) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0
    ? Math.max(1, Math.min(Math.floor(number), PORTAL_GUEST_LIMITS.maxGuests))
    : PORTAL_GUEST_LIMITS.maxGuests;
};

export const guestLimitMessage = (maxGuests, maxAdults) => {
  const total = capPortalGuests(maxGuests);
  const adults = Math.min(total, capPortalGuests(maxAdults));
  return `Up to ${total} travellers, with a maximum of ${adults} adults. ${GUEST_BOOKING_REQUIREMENT}`;
};

// Pricing category only. The accompanying-adult requirement is a separate rule.
export const guestCategoryForAge = (completedYears) => {
  if (!Number.isInteger(completedYears) || completedYears < 0) return null;
  return GUEST_ROWS.find((row) => completedYears >= row.minAge &&
    (row.maxAge === null || completedYears <= row.maxAge))?.key || null;
};
